import './AuthLayout.scss';

interface AuthLayoutProps {
  children: JSX.Element;
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="auth-layout">
      <div className="d-flex flex-column flex-md-row w-100 h-100">
        <div className="branding-container">
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <div className="logo-bg" />
            <span className="w-100 text-center tag-line">
              <b>Onsite Construction Inspection made Digital!</b>
            </span>
            <div className="text-center mb-auto login-bg" />
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center auth-form-container">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
